import React, { useState, useEffect } from "react";
import { Container, Box, Typography, TextField, Button, Alert } from "@mui/material";
import { collection, setDoc, doc, serverTimestamp, onSnapshot } from "firebase/firestore";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { useTranslation } from "react-i18next";

import { db } from "../../firebaseConfig";

function SignIn() {
  const [participantId, setParticipantId] = useState("");
  const [pin, setPin] = useState("");
  const [invites, setInvites] = useState([]);
  const [error, setError] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const listener = onSnapshot(collection(db, "invites"), (snapshot) => {
      setInvites(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    });
    return () => listener;
  }, []);

  const signInEmailPassword = async (email, password) => {
    try {
      await signInWithEmailAndPassword(getAuth(), email, password);
    } catch (error) {
      alert(error.message);
    }
  };

  const registerEmailPassword = async (invite, email, password, participantId) => {
    try {
      const response = await createUserWithEmailAndPassword(getAuth(), email, password);
      const user = response.user;

      await setDoc(
        doc(db, "users", user.uid),
        {
          id: user.uid,
          participantId: participantId,
          email: email,
          timestamp: serverTimestamp(),
        },
        { merge: true }
      );

      await updateProfile(user, {
        displayName: participantId,
      });

      await setDoc(
        doc(db, "invites", invite.id),
        {
          isRegistered: true,
          timestamp: serverTimestamp(),
        },
        { merge: true }
      );
    } catch (error) {
      alert(error.message);
    }
  };

  const handleSignIn = () => {
    const invite = invites.find(
      (invite) => invite.pin === pin && invite.participantId === participantId
    );
    if (!participantId || !pin) {
      setError(t("sign_in_required"));
    } else if (pin.length < 4) {
      setError(t("sign_in_pin"));
    } else if (!invite) {
      setError(t("could_not_log_you_in"));
    } else {
      let email = `davidb+${participantId}@viocare.com`;

      if (invite.isRegistered) {
        signInEmailPassword(email, "123456");
      } else {
        registerEmailPassword(invite, email, "123456", participantId);
      }
      setError("");
      setParticipantId("");
      setPin("");
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          {t("title_signin")}
        </Typography>
        <Box
          component="form"
          sx={{ mt: 1 }}
          onSubmit={(e) => {
            e.preventDefault();
            handleSignIn();
          }}
        >
          <TextField
            margin="normal"
            required
            fullWidth
            id="participantId"
            label={t("label_1")}
            name="participantId"
            autoComplete="participant-id"
            autoFocus
            value={participantId}
            onChange={(e) => setParticipantId(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="pin"
            label={t("label_2")}
            type="password"
            id="pin"
            autoComplete="current-pin"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
          />
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
          <Button type="submit" fullWidth variant="contained">
            {t("button_signin")}
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default SignIn;
